import useMutation from "src/hooks/useMutation";

/** GET /batches/:id/export-item-codes — xuất file serial (kể cả chưa scan đủ). */
export default function useBatchExportItemCodes() {
  return useMutation({
    path: "/api/v1/batches/id/export-item-codes",
    method: "GET",
  });
}
